var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "ES.70984594.png","uri@2x": __webpack_public_path__ + "ES.f861800d.png","uri@3x": __webpack_public_path__ + "ES.1a3fb1d1.png",
    width: 42,
    height: 30
});